import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { SimpleLoading, PromotionalFooterPure, InputHLPure } from "../../../pures";
import {
    DropDownBtnHLPure,
    ButtonHLPure,
    SubtitlePageHLPure
} from "../../../pures"
import VariablesPure from "./variables.pure";
import "./digital-contract-template-detail.css";

const DigitalContractTemplatesVariableView = ({
    selectedTemplate,
    getFormatVariables,
    formatVariables,
    setStateNameComponentUser,
    setHeaderTitleinDetail,
    laststateNameComponentUser,
    hideShowDetails
}) => {
    const [selectedFormatAllVariable, setSelectedAllFormat] = useState([]);
    const [selectedTemplateVariables, setSelectedTemplatesVariables] = useState(selectedTemplate.templateVariable);
    const { t } = useTranslation();


    useEffect(async () => {
        let formatVariables = await getFormatVariables()
        let allFormats = []
        formatVariables.map((format) => {
            allFormats.push(format)
        })
        setSelectedAllFormat(allFormats);
    }, []);

    const redirectToComponets = (name) => {
        setStateNameComponentUser(name);
        setHeaderTitleinDetail({ clicked: true, name: name })
    };

    const handleChangeVariables = (index, formatType) => {
        // console.log(selectedTemplateVariables, '1')
        // console.log(index, '2')
        // console.log(formatType, '3')
        // // // 1. Make a shallow copy of the items
        // // let items = [...this.state.items];
        // // // 2. Make a shallow copy of the item you want to mutate
        // // let item = { ...items[1] };
        // // // 3. Replace the property you're intested in
        // // item.name = 'newName';
        // // // 4. Put it back into our array. N.B. we *are* mutating the array here, 
        // // //    but that's why we made a copy first
        // // items[1] = item;
        // // // 5. Set the state to our new copy
        // // this.setState({ items });
    }

    return (
        < Grid
            className="digitalContractTemplates-body"
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
        >

            {/*Container primera seccion de items, fila*/}
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalContractTemplatesVariables-navbar"
            >
                {/* <SubtitlePageHLPure
                    subtitle={selectedTemplate.name}
                /> */}
                <h2>{selectedTemplate.name}</h2>
            </Grid>
            {/* <Grid
                item
                className="digitalContractTemplatesVariables-container"
            >
                <Grid
                    item
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}>
                    <label>Variable   </label>
                </Grid>
                <Grid
                    item
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}>
                    <label>Tipo de Dato   </label>
                </Grid>
                <Grid
                    item
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}>
                    <label>Formato    </label>
                </Grid>
                <Grid
                    item
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}>
                    <label>Unidades   </label>
                </Grid>
            </Grid> */}
            {/* <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12} className="digitalContractTemplatesVariables-container"> */}
            <Grid
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className='digitalContractTemplatesVariables-container-variables'>

                <ul>
                    {selectedTemplateVariables.length !== 0 ? selectedTemplateVariables.map((variable, index) => {
                        return (
                            <li>
                                <label className="digitalContractTemplatesVariables-variableName">{variable.name}</label>
                            </li>
                            //     <VariablesPure
                            //         selectedFormatAllVariable={selectedFormatAllVariable}
                            //         variable={variable}
                            //         index={index}
                            //         formatVariables={formatVariables}
                            //         handleChange={handleChangeVariables}
                            //     />
                        );
                    })
                        :
                        <label className="digitalContractTemplatesVariables-NoItems">{t("digitalContractTemplatesVariables.findingNot")}</label>}
                </ul>
            </Grid>

            {/* </Grid> */}
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalContractTemplatesAddButtons"
            >
                <Grid
                    item
                    className="digitalContractTemplatesAddSaveButton"
                >
                    <ButtonHLPure nameBtn={t("button.return")} onClickBtn={laststateNameComponentUser === "" ? hideShowDetails : (e) => redirectToComponets(laststateNameComponentUser)} primary />

                </Grid>
            </Grid>
            {/*Seccion de fila para footer */}
        </Grid>
    );
};

export default DigitalContractTemplatesVariableView;